<ion-header>
  <ion-toolbar class="header-color ion-text-center">
      <ion-buttons slot="start">
          <ion-menu-button auto-hide="false"></ion-menu-button>
      </ion-buttons>

      <ion-buttons slot="end">
          <ion-button (click)="toggleMap()">
                <ion-icon *ngIf="isMap" slot="icon-only" name="list"></ion-icon>
                <ion-icon *ngIf="!isMap" slot="icon-only" name="map"></ion-icon>
          </ion-button>
      </ion-buttons>
      <ion-searchbar searchIcon="pin" [(ngModel)]="selectedPlace" (click)="showAddressModal()" placeholder="Add city, landmark, or address"></ion-searchbar>
  </ion-toolbar>
  <app-promoga-alert></app-promoga-alert>
</ion-header>

<ion-content>
    <ion-toolbar class="toolbar-container">
        <ion-buttons class="button-groups">
            <ion-button class="feature-buttons" [ngClass]="{'selected_feature_button':filters.type === 'yoga'}" (click)="onTypeClick($event, 'yoga')">
              Yoga
            </ion-button>
            <ion-button class="feature-buttons" [ngClass]="{'selected_feature_button':filters.type === 'dance'}" (click)="onTypeClick($event, 'dance')">
              Dance
            </ion-button>
            <ion-button class="feature-buttons" [ngClass]="{'selected_feature_button':filters.type === 'group-fitness'}" (click)="onTypeClick($event, 'group-fitness')">
              Fitness
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

  <!-- Segment buttons with text and click listener -->
  <div id="list-view" *ngIf="!isMap">
      <!-- <ion-segment (ionChange)="segmentChanged($event)" color="secondary" class="borderBottom">
          <ion-segment-button value="yoga" class="segmentBtns">
              <ion-label>Yoga</ion-label>
          </ion-segment-button>
          <ion-segment-button value="dance" class="segmentBtns">
              <ion-label>Dance</ion-label>
          </ion-segment-button>
          <ion-segment-button value="groupfitness" class="segmentBtns">
              <ion-label>Group Fitness</ion-label>
          </ion-segment-button>
      </ion-segment> -->

      <div [hidden]=isDataHidden>
          <ion-button expand="block" color="secondary" (click)="presentModal()" class="moreFiltersBtn">More Filters</ion-button>
          <div *ngIf="filteredPromotions">
              <div *ngFor="let promotion of filteredPromotions">

                  <ion-card class="card_details">
                      <div class="herobg-img">
                          <div class="card_details__labels">
                              <span>
                                  <label *ngIf="promotion.classes.online_locations.length > 0 && !(promotion.classes.medium && promotion.classes.medium.length == 2)"
                                       class="online-label" (click)="presentAlertOnlineActivity()">
                                      online
                                  </label>
                                 <label class="online-label online-label&#45;&#45;hybrid" (click)="presentAlertHybridActivity()" 
                                 *ngIf="promotion.classes.medium && promotion.classes.medium.length == 2">
                                     <span>hybrid</span>
                                 </label>
                              </span>
                          </div>
                          <ion-button *ngIf="promotion.classes.has_ace == 1" class="social_btn" (click)="presentAlert()">
                              After Social
                          </ion-button>
                          <img [src]="promotion | getImage:'cover' " class="bg" (click)="showPromotionDetails(promotion)">
                          <div>
                              <ion-grid>
                                  <ion-row class="info">
                                      <ion-col size="6">
                                          <ion-avatar class="user_profile" (click)="showInstructor(promotion.classes.instructor)">
                                              <img [src]="promotion.classes.instructor | getImage:'profile' ">
                                          </ion-avatar>
                                          <ion-label class="textWhite userName" (click)="showInstructor(promotion.classes.instructor)">{{promotion.classes.instructor.first_name | titlecase}} {{promotion.classes.instructor.last_name | titlecase}} </ion-label>
                                      </ion-col>
                                      <ion-col size="6">
                                          <div class="details">
                                              <h5 class="session_location textWhite">
                                                  <span (click)="showStudio(promotion)">{{promotion.classes.venue.name|titlecase}}</span>
                                              </h5>
                                              <p class="session_location2">
                                                  <span class="orange_icon ion-margin-top">
<!--                                                      <ion-icon name="location-outline"></ion-icon>-->
                                                      <ion-icon name="pin"></ion-icon>
                                                  </span>
                                                  <span (click)="showStudio(promotion)">{{ promotion.classes.venue.city | titlecase  }}, {{ promotion.classes.venue.province_state.toUpperCase() }}</span>
                                              </p>
                                          </div>
                                      </ion-col>
                                  </ion-row>
                              </ion-grid>
                          </div>
                      </div>
                      <ion-grid (click)="showPromotionDetails(promotion)">
                          <ion-row>
                              <ion-col>
                                  <ion-card-header class="padding_0">
                                      <ion-card-title>{{promotion.classes.title | titlecase }}</ion-card-title>
                                      <ion-card-subtitle color="secondary" class="yoga_time">
                                         <span>
                                              {{promotion.classes | timezoneConverter:promotion?.next_session_timestamp :promotion?.classes.first_session}}
                                              <span *ngIf="promotion.classes.online_locations.length <= 0">{{ timezoneService.getTimezoneCode(promotion.classes.venue.time_zone) }}</span>   
                                              <span *ngIf="!(promotion.classes.online_locations.length <= 0)">{{ userTimezone }}</span>          
                                         </span>
                                          <svg *ngIf="promotion.classes.online_locations.length > 0"
                                               (click)="openTooltip($event)" xmlns="http://www.w3.org/2000/svg"
                                               class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                              <path fill-rule="evenodd"
                                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                                                    clip-rule="evenodd"/>
                                          </svg>
                                      </ion-card-subtitle>
                                  </ion-card-header>
                              </ion-col>
                              <ion-col>
                                  <ion-card-content class="padding_0">
                                      <div>
                                        <ion-card-title class="session_title textBlack">{{ promotion.session_value | sessionDisplay }}</ion-card-title>
                                        <ion-card-subtitle color="warning" class="session_price">
                                            <span class="discount-text">
                                                {{ promotion | retailPrice }}
                                            </span>
                                            <span class="total-amount-text">
                                                {{promotion | discountPrice }}
                                            </span>
                                        </ion-card-subtitle>
                                        <!--<ion-title color="warning" class="session_price"> {{promotion | discountPrice }}</ion-title>-->
                                      </div>
                                      <!-- <ion-title color="warning" class="session_price">dsdsdsd</ion-title> -->
                                      <!-- <span class="strike-original-price">{{ promotion | retailPrice }}</span>
                      <span class="bold energized">{{ promotion | discountPrice }}</span> -->
                                  </ion-card-content>
                              </ion-col>
                          </ion-row>
                      </ion-grid>
                  </ion-card>
              </div>
          </div>
          <div *ngIf="filteredPromotions.length === 0" class="padding warning_msg">
              <p class="title text-center">Sorry, there are no activities matching your criteria.</p>
              <p>Change your search filters, move the map area, or change the city to 
                  <a (click)="changeCity('vancouver')" style="text-decoration: none; font-weight: bold; cursor: pointer;" onmouseover="this.style.textDecoration='underline'" onmouseout="this.style.textDecoration='none'">Vancouver, BC</a> OR 
                  <a (click)="changeCity('toronto')" style="text-decoration: none; font-weight: bold; cursor: pointer;" onmouseover="this.style.textDecoration='underline'" onmouseout="this.style.textDecoration='none'">Toronto, ON</a>.
              </p>
          </div>
      </div>
      <div [hidden]=!isDataHidden>
          <ion-card>
              <ion-card-header>
                  <ion-card-title>Coming Soon</ion-card-title>
              </ion-card-header>

              <ion-card-content>
                  We will be adding this Dance/Fitness sessions in few days.
              </ion-card-content>
          </ion-card>
      </div>
  </div>

  <div id="map-view" [class.full-height]="isMap">
      <!-- <span>&nbsp;&nbsp;</span> -->
      <div style="height:100%;" #mapContainer id="map" [hidden]=!isMap></div>
  </div>
</ion-content>
<ion-footer class="ion-no-border">
  <!-- <ion-toolbar>
      <ion-segment value="all" color="secondary" [(ngModel)]="filters.duration" (ionChange)="durationChanged($event)">
          <ion-segment-button value="dropin">Drop-in</ion-segment-button>
          <ion-segment-button value="series">Series</ion-segment-button>
      </ion-segment>
  </ion-toolbar> -->
  <ion-toolbar>
    <ion-buttons>
      <ion-button class="bottom-buttons" [ngClass]="{'selected_button':filters.duration === 'dropin'}" (click)="onDurationClick($event, 'dropin')">
        Drop-in
      </ion-button>
      <ion-button class="bottom-buttons" [ngClass]="{'selected_button':filters.duration === 'series'}" (click)="onDurationClick($event, 'series')">
        Series
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
